import { connect } from 'react-redux';

import {
  mapStateToProps,
  mapDispatchToProps,
} from './props';

import MeetingStartedView from './MeetingStartedView';

export default connect(mapStateToProps, mapDispatchToProps)(MeetingStartedView);
